import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button, Message } from '@design-system-coopeuch/web';
import { casoBordeActions } from '../../../../application/actions/casoBordes';
import ImgUsuarioTCGold from '../../../assets/img/icon/User-ConTarjeta.svg';
import ImgUsuarioTCBlack from '../../../assets/img/icon/User-ConTarjetaBlack.svg';
import { WrapperCasosBordes } from './styles';
import { properties } from '../../../../utils/properties';
import TagManagerUtils from '../../../../utils/TagManagerUtils';

const UsuarioConTCThemplate = ({ tarjeta }) => {
  const dispatch = useDispatch();

  const paginaBeneficios = () => {
    window.location.href = properties.urlBeneficios;
  };

  const volveraCoopeuch = () => {
    window.location.href = properties.urlHomeCoopeuch;
  };

  useEffect(() => {
    dispatch(casoBordeActions.casoBordeEstado(true));
    TagManagerUtils.triggerEventMetodo(
      'trigger_event',
      '',
      '/verificacion',
      'Error',
      'Socio ya tiene tarjeta'
    );
  }, []);

  return (
    <WrapperCasosBordes>
      <h1>{properties.tarjetaActiva.titulo}</h1>
      <img src={tarjeta === 'gold' ? ImgUsuarioTCGold : ImgUsuarioTCBlack} alt="usuario TC" />
      <div className="info-box">
        <h2>{properties.tarjetaActiva.subtitulo}</h2>
        <p>{properties.tarjetaActiva.descripcion}</p>
      </div>
      <Button variant="btn" onClick={paginaBeneficios}>
        {properties.casosBordes.ListaNegra.textoBeneficios}
      </Button>
      <div className="mensaje-contenedor">
        <Message
          action={undefined}
          description="Llámanos al 600 200 1200"
          onClickClose={undefined}
          title="¿Perdiste tu tarjeta?"
          type="info"
        />
      </div>
      <div className="verificar">
        <Button variant="text" onClick={volveraCoopeuch} disabled={false}>
          {properties.casosBordes.ListaNegra.textoBotonDos}
        </Button>
      </div>
    </WrapperCasosBordes>
  );
};

UsuarioConTCThemplate.propTypes = {
  tarjeta: PropTypes.string.isRequired
}

export default UsuarioConTCThemplate;
